/**
 * 学年の定数定義
 */
export namespace GradeCode {
  // 小1
  export const ELEMENTARY_1: GradeMaster = {
    code: 'e1',
    label: '小学1年生',
    color: '--color-grade-elementary',
    order: 1,
  }
  // 小2
  export const ELEMENTARY_2: GradeMaster = {
    code: 'e2',
    label: '小学2年生',
    color: '--color-grade-elementary',
    order: 2,
  }
  // 小3
  export const ELEMENTARY_3: GradeMaster = {
    code: 'e3',
    label: '小学3年生',
    color: '--color-grade-elementary',
    order: 3,
  }
  // 小4
  export const ELEMENTARY_4: GradeMaster = {
    code: 'e4',
    label: '小学4年生',
    color: '--color-grade-elementary',
    order: 4,
  }
  // 小5
  export const ELEMENTARY_5: GradeMaster = {
    code: 'e5',
    label: '小学5年生',
    color: '--color-grade-elementary',
    order: 5,
  }
  // 小6
  export const ELEMENTARY_6: GradeMaster = {
    code: 'e6',
    label: '小学6年生',
    color: '--color-grade-elementary',
    order: 6,
  }
  // 中1
  export const JUNIOR_HIGH_1: GradeMaster = {
    code: 'j1',
    label: '中学1年生',
    color: '--color-grade-junior-high',
    order: 11,
  }
  // 中2
  export const JUNIOR_HIGH_2: GradeMaster = {
    code: 'j2',
    label: '中学2年生',
    color: '--color-grade-junior-high',
    order: 12,
  }
  // 中3
  export const JUNIOR_HIGH_3: GradeMaster = {
    code: 'j3',
    label: '中学3年生',
    color: '--color-grade-junior-high',
    order: 13,
  }
  // 高1
  export const HIGH_1: GradeMaster = {
    code: 'h1',
    label: '高校1年生',
    color: '--color-grade-high',
    order: 21,
  }
  // 高2
  export const HIGH_2: GradeMaster = {
    code: 'h2',
    label: '高校2年生',
    color: '--color-grade-high',
    order: 22,
  }
  // 高3
  export const HIGH_3: GradeMaster = {
    code: 'h3',
    label: '高校3年生',
    color: '--color-grade-high',
    order: 23,
  }
  // 学年一覧
  // N_LMS-395 初期リリース段階での教科・学年の制限に伴う内容修正
  export const LIST: GradeMaster[] = [ELEMENTARY_4, ELEMENTARY_5]
  // 全学年一覧
  //   内部処理でのみ使用し、全学年がリリースされたら削除する
  // N_LMS-784 学年の上下比較用に追加
  const FULL_LIST: GradeMaster[] = [
    ELEMENTARY_1,
    ELEMENTARY_2,
    ELEMENTARY_3,
    ELEMENTARY_4,
    ELEMENTARY_5,
    ELEMENTARY_6,
    JUNIOR_HIGH_1,
    JUNIOR_HIGH_2,
    JUNIOR_HIGH_3,
    HIGH_1,
    HIGH_2,
    HIGH_3,
  ]

  /**
   * codeの値から該当する定数を見つけて返す
   *
   * @param code 学年コード
   * @returns 学年の定数
   */
  export function findByCode(code: string): GradeMaster | undefined {
    return GradeCode.LIST.find((grade) => {
      return grade.code === code
    })
  }

  /**
   * 指定された学年以前の定数リストを返す
   *
   * @param code 対象の学年コード
   * @returns 学年の定数リスト
   */
  export function getSmallerList(code: string): GradeMaster[] {
    // 指定された学年情報を全学年から取得
    const currentGrade = FULL_LIST.find((grade) => {
      return grade.code === code
    })
    // 存在しない場合は空でreturn
    if (!currentGrade) {
      return []
    }

    // 指定された以前の学年のみ返す
    return GradeCode.LIST.filter((grade) => {
      return grade.order <= currentGrade.order
    })
  }

  /**
   * 学年マスターの型定義
   */
  export type GradeMaster = {
    /** コード */
    code: string
    /** ラベル */
    label: string
    /** css:色指定 */
    color: string
    /** 学年順(比較用) */
    order: number
  }
}
